import React from 'react'

import { format } from 'date-fns'

import { Button, Typography } from '@telavita-core/react-design-kit'

interface UnavailabilityInfoProps {
  restrictions: Date[]
  handleShowAvailabilityOptions: () => void
  alreadyHasData: boolean
}

const handleRestrictionMessage = (restrictions: Date[]) => {
  if (restrictions.length === 1) {
    return 'Defina outro horário para este dia'
  }

  return 'Defina outros horários para estes dias'
  
}

export const UnavailabilityInfo: React.FC<UnavailabilityInfoProps> = ({ restrictions, handleShowAvailabilityOptions, alreadyHasData }) => (
  <>
    <Typography variant='content2' center>
      Informe ao paciente que você está indisponível em:
    </Typography>
    
    {restrictions.map(restriction => (
      <Typography key={String(restriction)} variant='content2' weight='bolder'>
        {format(restriction, 'dd/MM/yyyy')}
      </Typography>
    ))}

    <Button 
      variant='text' 
      uppercase={false} 
      onClick={() => 
        alreadyHasData
          ? null
          : handleShowAvailabilityOptions()
      }
    >
      {handleRestrictionMessage(restrictions)}
    </Button>
  </>
)